import { useEffect, useState } from 'react';
import OneClick from './OneClick';

function App() {
  const [showOneClick, setShowOneClick] = useState(false);

  useEffect(() => {
    const handleClick = (e) => {
      const target = e.target;
      if (target.classList.contains('js-buy-one-click-v2')) {
        console.log('Клик по js-buy-one-click!');
        setShowOneClick(true); // показать компонент
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return (
      <div className="App">
        {showOneClick && <OneClick />}
      </div>
  );
}

export default App;
